// Breadcrumbs
jQuery(document).ready(function(){
setTimeout(function (){
$('.breadcrumbs .breadcrumbs__item .breadcrumbs__link[href="/"]').text("בית");
}, 500);
});

// Mobile nav menu
$(document).ready(function() {
  setTimeout(function() {
    var targetElement = $("nav.mobile-nav__group-wrapper.mobile-nav__wrapper .vertical-mega-menu li.buddha-menu-item:nth-child(5) a.mobile-nav__header-title--main span.mm-title");
    var text = targetElement.text();
    var modifiedText = text.replace("MIÓ", "<span class='custom-font'>MIÓ</span>");
    targetElement.html(modifiedText);
  }, 500);
});

$(document).ready(function() {
  setTimeout(function() {
    var targetElement = $("nav.mobile-nav__group-wrapper.mobile-nav__wrapper .vertical-mega-menu li.buddha-menu-item:nth-child(6) a.mobile-nav__header-title--main span.mm-title");
    var text = targetElement.text();
    var modifiedText = text.replace("YOKO", "<span class='custom-font'>YOKO</span>");
    targetElement.html(modifiedText);
  }, 500);
});

$(document).ready(function() {
  setTimeout(function() {
    var targetElement = $(".site-nav.mega-menu li.site-nav__link-container:nth-child(3) a.site-nav__main-link");
    var text = targetElement.text();
    var modifiedText = text.replace("MIÓ", "<span class='custom-font'>MIÓ</span>");
    targetElement.html(modifiedText);
  }, 500);
});

$(document).ready(function() {
  setTimeout(function() {
    var targetElement = $(".site-nav.mega-menu li.site-nav__link-container:nth-child(2) a.site-nav__main-link");
    var text = targetElement.text();
    var modifiedText = text.replace("YOKO", "<span class='custom-font'>YOKO</span>");
    targetElement.html(modifiedText);
  }, 500);
});
